import {
  fetch,
  normalize,
  extractHubURL, normalizeExcept,
} from '../../utils/dataAccess';
import {filterAction, sortAction} from "../../utils/filterAndSortUtils";

export function error(error) {
  return { type: 'PLAN_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'PLAN_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'PLAN_LIST_SUCCESS', retrieved };
}

export function list(page = 'plans') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        ({ retrieved: response.data, hubURL: extractHubURL(response) })
      )
      .then(({ retrieved, hubURL }) => {
        dispatch(loading(false));
        dispatch(success(retrieved));
      })
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset(eventSource) {
  return dispatch => {
    if (eventSource) eventSource.close();

    dispatch({ type: 'PLAN_LIST_RESET' });
  };
}

export function filter(filtersData) {
  return filterAction('PLAN_LIST_FILTER', 'plans', filtersData)
}

export function sort(sortData) {
  return sortAction('PLAN_LIST_SORT', 'plans', sortData)
}
